export default __webpack_public_path__ + "static/media/size_chart.2aabd734.jpg";